var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
import { SCALING } from "../../types/global";
export function scalingColorForTeam(ChampionDB, teamMembers) {
    var scalingColors = [];
    var filteredTeamMembers = teamMembers === null || teamMembers === void 0 ? void 0 : teamMembers.filter(function (ch) { return ch != null; });
    SCALING.forEach(function (scale) {
        var scalingValue = 0;
        if ((filteredTeamMembers === null || filteredTeamMembers === void 0 ? void 0 : filteredTeamMembers.length) === 5) {
            filteredTeamMembers.forEach(function (ch) {
                var champion = ChampionDB.find(function (champion) { return champion.Champion === ch; });
                scalingValue += parseInt(champion["Scaling_".concat(scale, "_Game")]);
            });
            scalingValue /= filteredTeamMembers.length;
            switch (true) {
                case scalingValue < 9:
                    scalingColors.push("Red");
                    break;
                case scalingValue <= 11:
                    scalingColors.push("Yellow");
                    break;
                default:
                    scalingColors.push("Green");
                    break;
            }
        }
    });
    return scalingColors;
}
function GetScalingColorsForTeams(_a) {
    var teamMembers = _a.teamMembers, ChampionDB = _a.ChampionDB, className = _a.className;
    var scalingColors = scalingColorForTeam(ChampionDB, teamMembers);
    return (_jsx("div", __assign({ className: twMerge("flex items-center justify-center gap-2", className) }, { children: scalingColors.length === 0 ? (_jsx("div", __assign({ className: "font-primary text-[16px] font-normal leading-4 text-neutral-500" }, { children: "N/A" }))) : (scalingColors === null || scalingColors === void 0 ? void 0 : scalingColors.map(function (color) { return (_jsx("div", { className: twMerge("h-2 w-6 rounded-full ", color === "Green" && "bg-scale-green ", color === "Yellow" && "bg-scale-yellow ", color === "Red" && "bg-scale-red ") }, color)); })) })));
}
export default GetScalingColorsForTeams;
